import { takeLatest, call, all, put, fork } from 'redux-saga/effects'

import * as actions from '../../actions/actions'

import { users, enableUser, disableUser, resetUser, deleteUser } from "../../../api/userApi"
import {push} from "connected-react-router";

export default function* userSaga() {
  yield all([
    fork(watchFetchUserRequest),
    fork(watchEnableUserRequest),
    fork(watchDisableUserRequest),
    fork(watchResetUserRequest),
    fork(watchDeleteUserRequest),
  ]);
}

function* watchFetchUserRequest() {
  yield takeLatest(
    actions.FETCH_USER_REQUEST,
    fetchUserRequest
  )
}

function* fetchUserRequest() {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(users)
    yield put({ type: actions.FETCH_USER_SUCCESS, users: data })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_USER_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchEnableUserRequest() {
  yield takeLatest(
    actions.ENABLE_USER_REQUEST,
    enableUserRequest
  )
}

function* enableUserRequest(user) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(enableUser, user.value)
    yield put({ type: actions.ENABLE_USER_SUCCESS, users: data })
    yield put(push(`/user`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.ENABLE_USER_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }else if(error.request)
    {
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  }
}

function* watchDeleteUserRequest() {
  yield takeLatest(
    actions.DELETE_USER_REQUEST,
    deleteUserRequest
  )
}

function* deleteUserRequest(user) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(deleteUser, user.value)
    yield put({ type: actions.DELETE_USER_SUCCESS, users: data })
    yield put(push(`/user`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    yield put({ type: actions.DELETE_USER_FAILURE, error: error.response })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  }
}

function* watchDisableUserRequest() {
  yield takeLatest(
    actions.DISABLE_USER_REQUEST,
    disableUserRequest
  )
}

function* disableUserRequest(user) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(disableUser, user.value)
    yield put({ type: actions.DISABLE_USER_SUCCESS, users: data })
    yield put(push(`/user`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.DISABLE_USER_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }else if(error.request)
    {
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  }
}

function* watchResetUserRequest() {
  yield takeLatest(
    actions.RESET_USER_REQUEST,
    resetUserRequest
  )
}

function* resetUserRequest(user) {
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(resetUser, user.value)
    yield put({ type: actions.RESET_USER_SUCCESS, users: data })
    yield put(push(`/user`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.RESET_USER_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }else if(error.request)
    {
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
    }
  }
}